import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OrderPatient } from '@classes/order/orderPatient';

@Component({
  selector: 'app-order-step-patients-table',
  templateUrl: './order-step-patients-table.component.html',
  styleUrls: ['./order-step-patients-table.component.scss']
})
export class OrderStepPatientsTableComponent implements OnInit {
  @Input() patients: OrderPatient[] = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns: string[] = ['firstname', 'birthname', 'lastname', 'birthdate', 'ipp', 'productType', 'quantity'];
  dataSource: MatTableDataSource<OrderPatient>;

  constructor() { }

  ngOnInit(): void {
    this.initTable();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  initTable(): void{
    this.dataSource = new MatTableDataSource(this.patients);
  }

}
